import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckBox, FlexContainer, PlainButton, Text } from '@bos/ui';
import { useState } from 'react';
import { useController } from 'react-hook-form';
export const CheckBoxListField = ({ options, control, name, registerOptions, showMoreOptions, }) => {
    const { field, fieldState } = useController({
        control,
        name,
        defaultValue: [],
        ...registerOptions,
    });
    const currentFieldValue = field.value || [];
    const [showAllOptions, setShowAllOptions] = useState(!showMoreOptions);
    const handleCheckedChange = (optionValue, newValue) => {
        const valueToAdd = Array.isArray(optionValue) ? optionValue : [optionValue];
        if (newValue) {
            field.onChange([...currentFieldValue, ...valueToAdd]);
            return;
        }
        field.onChange(currentFieldValue.filter((valueOption) => {
            return !valueToAdd.includes(valueOption);
        }));
    };
    const slicedOptions = options.slice(showMoreOptions?.amount);
    const hasExtraOptionsChecked = slicedOptions.some((option) => Array.isArray(option.value)
        ? option.value.some((val) => currentFieldValue.includes(val))
        : currentFieldValue.includes(option.value));
    if (hasExtraOptionsChecked && !showAllOptions) {
        setShowAllOptions(true);
    }
    const toggleShowAllOptions = () => setShowAllOptions((prev) => !prev);
    const mappedOptions = options.map((option) => {
        const checked = Array.isArray(option.value)
            ? option.value.every((val) => currentFieldValue.includes(val))
            : currentFieldValue.includes(option.value);
        const key = Array.isArray(option.value)
            ? option.value.join(',')
            : option.value;
        const onCheckedChange = (newValue) => handleCheckedChange(option.value, newValue);
        return (_jsxs(FlexContainer, { verticalAlign: 'center', gap: true, children: [_jsx(CheckBox, { ...option, checked: checked, onCheckedChange: onCheckedChange }), option.afterElement] }, key));
    });
    const { error } = fieldState;
    const maybeErrorMessage = error?.message && (_jsx(Text, { color: 'danger', variant: 'b3', children: error.message }));
    const shouldShowMoreButton = !!(showMoreOptions?.amount &&
        options.length > showMoreOptions.amount &&
        !showAllOptions);
    const maybeShowMoreButton = shouldShowMoreButton && (_jsx(PlainButton, { type: 'button', onClick: toggleShowAllOptions, children: _jsx(Text, { color: 'grey', variant: 'b2', underline: true, children: showMoreOptions?.text }) }));
    const slicedMappedOptions = mappedOptions.slice(0, showMoreOptions?.amount);
    const maybeAllMappedOptions = showAllOptions
        ? mappedOptions
        : slicedMappedOptions;
    return (_jsxs(FlexContainer, { direction: 'column', gap: true, children: [maybeAllMappedOptions, maybeShowMoreButton, maybeErrorMessage] }));
};
